import React from 'react'
import { Search } from 'lucide-react'
import { Input } from '@/shared/ui'
import { listPublicFaqs, type Faq } from '../services/faqService'
import { filterFaqs } from '../utils/filterFaqs'
import FaqAccordion from './FaqAccordion'

export default function FaqHomeSection() {
  const [items, setItems] = React.useState<Faq[]>([])
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState<string | null>(null)
  const [query, setQuery] = React.useState('')

  React.useEffect(() => {
    let cancelled = false

    ;(async () => {
      setLoading(true)
      setError(null)
      try {
        const list = await listPublicFaqs()
        if (!cancelled) setItems(list)
      } catch (e: any) {
        if (!cancelled) setError(e?.message ?? 'Falha ao carregar FAQs')
      } finally {
        if (!cancelled) setLoading(false)
      }
    })()

    return () => {
      cancelled = true
    }
  }, [])

  const filteredItems = React.useMemo(
    () => filterFaqs(items, query),
    [items, query],
  )

  const hasItems = items.length > 0
  const hasFiltered = filteredItems.length > 0

  return (
    <section id="faq" className="py-10 sm:py-16">
      <div className="mx-auto max-w-[1100px] px-6">
        <div className="mb-6 sm:mb-8 text-center">
          <h2 className="text-2xl sm:text-3xl font-semibold">Dúvidas Frequentes</h2>
          <p className="mt-2 text-sm sm:text-base text-foreground/80">
            Veja as principais dúvidas que os usuários têm sobre o Cripto Alert
          </p>
        </div>
        {error && (
          <div className="mb-4 rounded-md border border-destructive/30 bg-destructive/10 p-2 text-sm text-destructive-foreground">
            {error}
          </div>
        )}
        {!loading && hasItems && (
          <div className="mb-4 flex justify-center">
            <div className="relative w-full max-w-md">
              <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-foreground/60" />
              <Input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Buscar nas dúvidas"
                className="pl-9"
              />
            </div>
          </div>
        )}
        {loading ? (
          <div className="text-sm text-foreground/70">Carregando...</div>
        ) : !hasItems ? (
          <div className="text-sm text-foreground/70">Nenhuma dúvida cadastrada no momento.</div>
        ) : !hasFiltered ? (
          <div className="text-sm text-foreground/70">Nenhuma dúvida encontrada para a busca.</div>
        ) : (
          <FaqAccordion items={filteredItems} />
        )}
      </div>
    </section>
  )
}

